import { createDivIn, createExternalImgIn, createParagraphIn, setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import IconX from '@static/images/icon_x.svg';
export class UIMMobileBottomDrawer {
    createTitle(title) {
        const titleContainer = createDivIn(this.container, 'drawer-title');
        this.title = createParagraphIn(titleContainer, title, 'drawer-title-text');
        const crossContainer = createDivIn(titleContainer, 'in-game-information-title-container arrows-container');
        createExternalImgIn(crossContainer, IconX, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'arrows');
        setElementOnClick(crossContainer, ()=>this.toggleDrawer());
    }
    createContent() {
        const contentContainer = createDivIn(this.container, 'drawer-content');
        this.content = contentContainer;
    }
    toggleDrawer() {
        this.container.remove();
        this.background.remove();
    }
    constructor(title){
        const body = document.body;
        this.container = createDivIn(body, 'drawer-container');
        this.createTitle(title);
        this.createContent();
        this.background = createDivIn(body, 'drawer-background');
        setElementOnClick(this.background, ()=>this.toggleDrawer());
    }
}
